//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LegacyCheckbox',
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isClicked: false,
    };
  },
  methods: {
    onClick() {
      this.isClicked = !this.isClicked;
      this.$emit('on-click', this.isClicked);
    },
  },
};
